import React from 'react';
import { Drawer, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CustomRightDrawer = ({ open, onClose, title, children, width = 450 }) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box
        sx={{
          width,
          padding: 2,
          mt: 8,
          height: '100vh',
          position: 'relative',
        }}>
        {(title || onClose) && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: '#fff',
              padding: '12px 18px',
              borderBottom: '1px solid #ddd',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              zIndex: 1,
            }}>
            <Typography variant="h6">{title}</Typography>
            <IconButton onClick={onClose} disableFocusRipple>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        )}

        <Box sx={{ mt: title ? 8 : 0 }}>{children}</Box>
      </Box>
    </Drawer>
  );
};

export default CustomRightDrawer;
